export enum OutOrderStateEnum {
  RECEIVED = 'RECEIVED',
  PREPARING_FOR_DISPATCH = 'PREPARING_FOR_DISPATCH',
  READY_TO_INVOICE = 'READY_TO_INVOICE',
  READY_TO_PACKING = 'READY_TO_PACKING',
  AWAITING_VALIDATION = 'AWAITING_VALIDATION',
  VALIDATING = 'VALIDATING',
  BLOCKED_TO_DISPATCH = 'BLOCKED_TO_DISPATCH',
  UNKNOWN = "UNKNOWN",
  PALLETS_RESERVED = "PALLETS_RESERVED",
  READY_TO_DISPATCH = "READY_TO_DISPATCH",
  DISPATCHING = "DISPATCHING",
  FINISHED = "FINISHED",
  CREATED_AT_WMS = "CREATED_AT_WMS"
}

export interface OutOrderExecutionPlanInterface {
  pickingSteps: {
    x: number,
    y: number,
    sku: string,
    quantity: number,
  }[],
  selectedPallets: {
    sku: string,
    palletId: string,
    quantity: number,
  }[]
};

export interface FinishedOutOrderSkuGroup {
  sku: string,
  productName: string,
  quantity: number,
  packSize: number,
}

export interface FinishedOutOrderManifest {
  sku: string,
  name: string,
  quantity: number,
}

export interface FinishedOutOrder {
  id: string,
  no: string,
  date: number,
  state: OutOrderStateEnum,
  tenantId: string,
  invoiceRequested: boolean,
  executionPlan?: OutOrderExecutionPlanInterface,
  executionPlanVersion: number | null,
  expeditionGroundPositionGroupId: string | null,
  origin: string | null,
  createdAt: number
  updatedAt: number | null,
  deletedAt: number | null,
  description: string | null,
  skuGroups: FinishedOutOrderSkuGroup[] | null,
  outOrderEventHistoryDispatchedAt: number | null,
  manifest?: FinishedOutOrderManifest[];
  commentsQty?: number;
  outOrderCrates: OutOrderCrate[];
}

interface OutOrderCrate {
  crateId: string,
  outOrderId: string,
  createdAt: number,
  updatedAt: number,
}
export interface OutOrderComments {
  id: string,
  outOrderId: string,
  ownerId: string,
  stage: string,
  tenantId: string,
  text: string,
  timestamp: string,
  type: string,
  user: { firstName: string, lastName: string };
}
